/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

const enabled = () => {
    const flag = import.meta.env.VITE_ENABLE_TELEGRAM_ERRORS
    return String(flag).toLowerCase() === 'true'
}

const token = () => String(import.meta.env.VITE_TELEGRAM_BOT_TOKEN || '')
const chatId = () => String(import.meta.env.VITE_TELEGRAM_CHAT_ID || '')

const safeString = (val: any) => {
    try {
        if (!val) return ''
        if (typeof val === 'string') return val
        return JSON.stringify(val).slice(0, 1500)
    } catch {
        return ''
    }
}

const buildMessage = (err: Error, extra: any) => {
    const app = String(import.meta.env.VITE_APP_NAME || 'CRMSeller')
    const when = new Date().toISOString()
    const loc = typeof window !== 'undefined' ? window.location.href : ''
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''
    const parts = [
        `App: ${app}`,
        `Time: ${when}`,
        loc && `URL: ${loc}`,
        `Message: ${err?.message || 'Unknown'}`,
        err?.stack && `Stack: ${err.stack}`,
        ua && `Agent: ${ua}`,
        extra && `Extra: ${safeString(extra)}`,
    ].filter(Boolean)
    let text = parts.join('\n')
    if (text.length > 3900) text = text.slice(0, 3900) + '\n…'
    return text
}

export const reportError = async (error: unknown, extra?: any) => {
    try {
        console.error('ReportError:', error, extra)
        const err = error instanceof Error ? error : new Error(String(error || 'Unknown error'))
        if (!enabled() || !token() || !chatId()) return
        const text = buildMessage(err, extra)
        const url = `https://api.telegram.org/bot${token()}/sendMessage`
        await fetch(url, {
            method: 'POST',
        }).catch(() => {})
    } catch {}
}

export default reportError
